import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import type {
    PrhHolidayHomeOnsaDTO,
    PrhHouseOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import { refreshBbrSelectorAtom } from '../atoms/refreshBbrSelectorAtom';
import { COVERABLE_CODE } from '../../constants/coverable';

export const getPrhBBRSelector = selector<PrhHouseOnsaDTO | PrhHolidayHomeOnsaDTO>({
    key: 'getPrhBBRSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);
        get(refreshBbrSelectorAtom);

        const bbrData =
            currentProduct.flavourCode === COVERABLE_CODE.prhHouse
                ? await OnlineSalesUnauthenticated.getHouseBBRData(
                      jobNumber,
                      sessionId,
                      currentProduct.fixedId,
                      !isLoggedOn
                  )
                : await OnlineSalesUnauthenticated.getHolidayHomeBBRData(
                      jobNumber,
                      sessionId,
                      currentProduct.fixedId,
                      !isLoggedOn
                  );

        return bbrData;
    }
});
